import React, { Component } from "react";
import LanguageVersionDisplay from "./LanguageVersionDisplay"; // New component for individual lang versions
import LanguageVersionForm from "./LanguageVersionForm"; // New component for add/edit form

export default class ConceptualQuestionManager extends Component {
  state = {
    showAddForm: false,
  };

  toggleAddForm = () => {
    this.setState((prevState) => ({ showAddForm: !prevState.showAddForm }));
  };

  handleAddLanguageVersion = (formData) => {
    // Add commonQuestionId to the form data before passing up
    this.props.onAddLanguageVersion({
      ...formData,
      commonQuestionId: this.props.commonQuestionId,
    });
    this.setState({ showAddForm: false }); // Close form after submission
  };

  render() {
    const {
      commonQuestionId,
      languageVersions,
      onUpdateLanguageVersion,
      onDeleteLanguageVersion,
    } = this.props;
    const conceptualQuestionCompanyId =
      languageVersions &&
      languageVersions.length > 0 &&
      languageVersions[0].companyId
        ? languageVersions[0].companyId
        : null;

    return (
      <div className="box mb-5">
        <h3 className="title is-5">
          Conceptual Question ID:{" "}
          <span className="has-text-weight-normal">{commonQuestionId}</span>
          {conceptualQuestionCompanyId && (
            <span className="tag is-info is-light ml-2">
              Company: {conceptualQuestionCompanyId}
            </span>
          )}
          {!conceptualQuestionCompanyId && (
            <span className="tag is-light ml-2">Global Question</span>
          )}
        </h3>
        {/* ... (map over languageVersions to render LanguageVersionDisplay) ... */}
        {languageVersions && languageVersions.length > 0 ? (
          languageVersions.map((lv) => (
            <LanguageVersionDisplay
              key={`${lv.languageCode}-${lv.commonQuestionId}`}
              languageVersion={lv} // lv contains companyId if set, and createdAt
              onUpdate={onUpdateLanguageVersion} // This onUpdate is from MessageBoardAdmin
              onDelete={onDeleteLanguageVersion} // This onDelete is from MessageBoardAdmin
            />
          ))
        ) : (
          <p className="mb-3">
            No language versions exist for this conceptual question yet.
          </p>
        )}

        {this.state.showAddForm && (
          <div
            className="mt-4 p-4"
            style={{ border: "1px solid #dbdbdb", borderRadius: "4px" }}
          >
            <h4 className="subtitle is-6">Add New Language Version</h4>
            <LanguageVersionForm
              commonQuestionId={commonQuestionId} // Pass commonQuestionId
              onSubmit={this.handleAddLanguageVersion}
              onCancel={this.toggleAddForm}
            />
          </div>
        )}

        <button
          onClick={this.toggleAddForm}
          className="button is-link is-outlined is-small mt-3"
        >
          {this.state.showAddForm
            ? "Cancel Adding Version"
            : "+ Add Language Version"}
        </button>
      </div>
    );
  }
}
